import React, { useState } from "react";
import CustomNavbar from "../../components/common/CustomNavbar";
import PageLayout from "../../components/layouts/PageLayout";
import { AddTemplateSection } from "./Addtemplatesection";
import { SectionId } from "./SidebarConfig";
import { SendSingleSection } from "./Sendsinglesection";
import { SendBulkSection } from "./Sendbulksection";
import { PlaceholderSection } from "./Placeholdersection";
import { ApiSidebar } from "./Apisidebar";
import { GetTemplatesSection } from "./GetTemplateSection";
import { OverviewSection } from "./Overview";
import { AddTemplateUtilitySection } from "./AddTemplate/UtilityTemplate";
import { AddTemplateAuthSection } from "./AddTemplate/AuthenticationTemplate";
import { AddTemplateMarketingSection } from "./AddTemplate/MarketingTemplates";
import { MessageReportSection } from "./MessageReportSection";
import { AddTrainBotRuleSection } from "./TrainBot/AddTrainBotRuleSection";
import { GetTrainBotSection } from "./TrainBot/GetTrainBotSection";
import { TokenFile } from "./TokenFile";

const SECTION_MAP: Record<SectionId, React.ReactNode> = {
  "send-single": <SendSingleSection />,
  "send-bulk": <SendBulkSection />,
  "get-template": <GetTemplatesSection />,
  "add-template-auth" : <AddTemplateAuthSection />,
  "add-template-marketing" : <AddTemplateMarketingSection />,
  "add-template-utility" : <AddTemplateUtilitySection />,
  "message-report": <MessageReportSection />,
  "add-rules": <AddTrainBotRuleSection />,
  "get-rules": <GetTrainBotSection />,
  overview: <OverviewSection />,
  token: <TokenFile />,
  errors: <PlaceholderSection title="Errors & Codes" />,
};

export function ApiDocumentation() {
  const [activeSection, setActiveSection] = useState<SectionId>("add-template-auth");

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <span className="font-bold text-lg uppercase">API Documentation</span>
          </div>
        </CustomNavbar>
      }
    >
      <div className="flex h-full min-h-[calc(100vh-64px)] px-4">
        <ApiSidebar active={activeSection} onChange={setActiveSection} />

        <main className="flex-1 overflow-y-auto px-8 py-8 bg-white">
          <div className="max-w-3xl mx-auto">
            {SECTION_MAP[activeSection]}
          </div>
        </main>
      </div>
    </PageLayout>
  );
}
